import Home from "./pages/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Routes } from "react-router-dom";
import ShopPage2 from "./pages/ShopPage/ShopPage2";
import AboutPage from "./pages/AboutPage/AboutPage";
import { ContactPage } from "./pages/ContactPage/ContactPage";
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import CartPage from "./pages/CartPage/CartPage";
import ScrollToTop from "./components/ScrollToTop";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Wishlist from "./pages/Wishlist/Wishlist";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import CheckoutPage from "./pages/CheckoutPage/CheckoutPage";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import RecoverPassword from "./pages/RecoverPassword/RecoverPassword";
import PaymentSuccessfull from "./pages/payment-status/PaymentSuccessfull";
import PaymentUnsuccessful from "./pages/payment-status/PaymentUnsuccessful";
import OrderHistory from "./pages/OrderHistory/OrderHistory";
import PrivacyPolicy from "./pages/FooterPages/PrivacyPolicy";
import InvestorRelations from "./pages/FooterPages/InvestorRelations";
import Careers from "./pages/FooterPages/Careers";
import ReturnPolicy from "./pages/FooterPages/ReturnPolicy";
import GiftPolicy from "./pages/FooterPages/GiftPolicy";
import TermsOfUse from "./pages/FooterPages/TermsOfUse";
import FAQs from "./pages/FooterPages/FAQs";
import FranchisePage from "./pages/FooterPages/FranchisePage";
import SiteMap from "./pages/FooterPages/SiteMap";
import SaleProducts from "./pages/Sale Products/SaleProducts";
import FlashSale from "./pages/Flash Sale/FlashSale";
import { useState } from "react";
// imports

function App() {
  const [navigatedCategory, setNavigatedCategory] = useState("");

  return (
    <div className="App">
      <ToastContainer />
      <FlashSale />
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={<Home setNavigatedCategory={setNavigatedCategory} />}
        />
        <Route
          path="/shop"
          element={
            <ShopPage2
              navigatedCategory={navigatedCategory}
              setNavigatedCategory={setNavigatedCategory}
            />
          }
        />
        <Route path="/shop/:searchName" element={<ShopPage2 />} />
        <Route path="/shop/:category" />
        <Route path="/productdetails/:productId" element={<ProductDetails />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset" element={<RecoverPassword />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/order-history" element={<OrderHistory />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment-successful" element={<PaymentSuccessfull />} />
        <Route path="/payment-unsuccessful" element={<PaymentUnsuccessful />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/return-policy" element={<ReturnPolicy />} />

        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/grievance" element={<ContactPage />} />

        <Route path="/sitemap" element={<SiteMap />} />
        <Route path="/sale-products" element={<SaleProducts />} />
        {/* <Route path="/investor-relations" element={<InvestorRelations />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/franchise" element={<FranchisePage />} />
        <Route path="/gift-card-policy" element={<GiftPolicy />} />*/}
      </Routes>
      <ToastContainer position="top-center" />
    </div>
  );
}

export default App;
